import { render } from "./ConfigProgression.vue?vue&type=template&id=55adc014&scoped=true"
import script from "./ConfigProgression.vue?vue&type=script&lang=js"
export * from "./ConfigProgression.vue?vue&type=script&lang=js"

import "./ConfigProgression.vue?vue&type=style&index=0&id=55adc014&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55adc014"]])

export default __exports__